import { useQuery } from '@tanstack/react-query';
import { clientService } from '@/api/services/client.service';
import { queryKeys } from '../query-keys';

export const useClientDashboard = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeys.dashboard.client(),
    queryFn: () => clientService.getDashboard(),
    staleTime: 1 * 60 * 1000, // 1 minute
    retry: 1, // Retry once on failure
    retryDelay: 1000, // Wait 1 second before retry
    enabled: options?.enabled !== false,
  });
};
